// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deck-cookie-notice {
  position: relative;
  height: 100%;
  text-align: center;
}
.deck-cookie-notice-inner {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.deck-cookie-notice-content {
  max-width: 420px;
  margin: 0 auto;
  text-align: left;
}
.deck-cookie-notice-link {
  white-space: nowrap;
}
.deck-cookie-notice-btn {
  margin-top: 1rem;
}
.deck-cookie-notice-btn span {
  pointer-events: none;
}
.nkl-deck-cookie-notice-close-btn {
  position: absolute;
  right: -16px;
  top: -16px;
  width: 20px;
  height: 20px;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.nkl-deck-cookie-notice-close-icon {
  width: 100%;
  fill: currentColor;
}
.ant-drawer.ant-drawer-bottom.ant-drawer-open {
  z-index: 1002;
}
`, "",{"version":3,"sources":["webpack://./src/deck/cookie-notice/cookie-notice.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAEA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAAJ;AAGA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAIA;EACI,mBAAA;AAFJ;AAKA;EACI,gBAAA;AAHJ;AAEA;EAIQ,oBAAA;AAHR;AAOA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;AALJ;AAQA;EACI,WAAA;EACA,kBAAA;AANJ;AAWQ;EACI,aAAA;AATZ","sourcesContent":[".deck-cookie-notice {\n    position: relative;\n    height: 100%;\n    text-align: center;\n}\n\n.deck-cookie-notice-inner {\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.deck-cookie-notice-content {\n    max-width: 420px;\n    margin: 0 auto;\n    text-align: left;\n}\n\n.deck-cookie-notice-link {\n    white-space: nowrap;\n}\n\n.deck-cookie-notice-btn {\n    margin-top: 1rem;\n\n    span {\n        pointer-events: none;\n    }\n}\n\n.nkl-deck-cookie-notice-close-btn {\n    position: absolute;\n    right: -16px;\n    top: -16px;\n    width: 20px;\n    height: 20px;\n    border: none;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n}\n\n.nkl-deck-cookie-notice-close-icon {\n    width: 100%;\n    fill: currentColor;\n}\n\n.ant-drawer {\n    &.ant-drawer-bottom {\n        &.ant-drawer-open {\n            z-index: 1002;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
